import { doTransition, doWaitImageByTime, isAnnGF } from '../helpers/helpers';
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { images } from "./images";
import { alex } from '../characters/Alex';
import { mc } from '../characters/MC';
import Question from '../../src/shell/Questions';
import { ann } from '../characters/Ann';
import { empty } from '../characters/empty';
import { V7AlexAnnMCAfter } from './V7';

export const V7AlexAnnMC = async (): Promise<any> => {
    doTransition(images.v7.V7AlexAnnMC_0);
    alex.talk(`I'm so glad you came! You are a lifesaver!`);

    let optionTitle = "Don't risk it";
    if (mc.properties.annStatus === "gf") {


    } else {
        optionTitle = "Don't check her out";

    }
    await mc.setQuestion(new Question({ text: `Of course! I'm always glad to help.`, options: { think: false }, key: `V7AlexAnnMCCheckedOutAlex` })
        .option({ title: `Check Alex out`, key: true })
        .option({ title: optionTitle, key: false }));


    if (Question.globalAnswers.V7AlexAnnMCCheckedOutAlex) {
        ImageClass.setImage(images.v7.V7AlexAnnMC_1, { duration: 1 });
        await mc.set((properties) => {
            properties.alexRelationship++;
        });
        mc.think(`Damn, her body is so hot.`);
    }
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v7.V7AlexAnnMC_0);
        mc.talk(`Hey Ann!`);
        ImageClass.setImage(images.v7.V7AlexAnnMC_4);
        ann.talk(`Hey! Hehe.`);
        ann.talk(`I told her that if someone can help her fix her laptop it's you!`);
        mc.talk(`How did you know? We never talked about that.`);
        ImageClass.setImage(images.v7.V7AlexAnnMC_2);
        ann.talk(`I know how gamers are! They will always find a way to fix their PC if it breaks down.`);
        mc.talk(`That's kinda... True.`);
        ann.talk(`Hehe.`);


    } else {
        ImageClass.setImage(images.v7.V7AlexAnnMC_0);
        ann.talk(`Thanks for coming.`);
        ImageClass.setImage(images.v7.V7AlexAnnMC_2);
        ann.talk(`It's important for me that you know that I don't take it for granted!`);

    }

    mc.talk(`Ok, so where is the patient?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_3, { duration: 1 });
    alex.talk(`Woah! Hold on there!`);
    alex.talk(`Take a look around! What do you think about my designing skills?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_5);
    alex.talk(`That's my nightstand! It's not new though... My parents bought a new one and let me take theirs.`);
    mc.talk(`It's nice... The picture is in case you forget what you look like?`);
    alex.talk(`It was either that or a mirror, but I want to see myself when I'm looking good!`);
    await alex.setQuestion(new Question({ text: `It was either that or a mirror, but I want to see myself when I'm looking good!`, options: { think: false }, key: `V7AlexAnnMCComplimentAlex` })
        .option({ title: `Compliment Alex`, key: true })
        .option({ title: isAnnGF() ? `Don't risk it` : `Don't compliment`, key: false }));


    if (Question.globalAnswers.V7AlexAnnMCComplimentAlex) {
        mc.talk(`You always look good. Could've easily gone with a mirror.`);
        alex.talk(`Oh! Well thank you!`);



    } else {


    }
    ImageClass.setImage(images.v7.V7AlexAnnMC_6);
    alex.talk(`That's the picture I showed you yesterday.`);
    mc.talk(`Yeah, I see.`);
    mc.talk(`It looks heavy, who helped you with that?`);
    ann.talk(`Me!`);
    mc.talk(`Really?`);
    alex.talk(`Of course! Together we are unbeatable!`);
    mc.think(`That's debatable...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_8);
    alex.talk(`And that's my workspace...`);
    alex.talk(`Well... Not really a workspace since my laptop is broken...`);
    mc.think(`Another picture of herself...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_8);
    alex.talk(`You've gone quiet. Did my picture scare you?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_9);
    ann.talk(`Of course he is scared! Who else has this many pictures of herself in her own room?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_16);
    alex.talk(`Don't judge me... That's the only thing I had lying around... I didn't want the place to be completely empty.`);
    ann.talk(`Hehe, I'm just joking!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_15);
    alex.talk(`...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_7, { duration: 1 });
    alex.talk(`So... What do you say doctor? Can you fix it?`);
    mc.talk(`It's not looking good from here, but I'll try my best.`);
    alex.talk(`That's all I can ask.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_11);
    if (isAnnGF() && !ann.properties.isCorrupted) {
        ann.talk(`Hey! I'm the one who's supposed to be the doctor around here.`);
        alex.talk(`Not right now...`);
        ann.talk(`That's not fair...`);
    } else {
        ann.talk(`Hey! I'm the one who's supposed to be the doctor around here.`);
        alex.talk(`Didn't you say you don't want to do that anymore?`);
        ann.talk(`Oh... Yeah... Guess I did...`);


    }
    mc.talk(`Blue screen of death... And restarting isn't helping...`);
    doWaitImageByTime(images.v7.V7AlexAnnMC_12);
    alex.talk(`Oh no! Is that bad?`);
    mc.talk(`Definitely not good...`);
    alex.talk(`Don't tell me I need to buy a new laptop! I paid upfront for this place! I don't have enough money! I'll have to wait for next month.`);
    mc.talk(`There are a few things that I can try.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_13);
    alex.talk(`So there is hope!`);
    mc.talk(`How did it happened again?`);
    alex.talk(`I don't know! I didn't do anything! I was just going over my Insta comments and suddenly that screen appeared.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_17);
    ann.talk(`That's what happens when you have too many comments hehe.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_16);
    alex.talk(`I don't have that many.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_11);
    ann.talk(`Yeah, right.`);
    mc.talk(`I've just checked if you have any restore points in safe mode and you don't have any...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_12);
    alex.talk(`And now in English...?`);
    mc.talk(`I might have to format your laptop and reinstall the operation system from scratch.`);
    mc.talk(`Are you ok with that?`);
    alex.talk(`Do I have a choice?`);
    mc.talk(`You can leave it like that and use it as a doorstopper.`);
    alex.talk(`Oh...`);
    alex.talk(`Well... The laptop isn't working anyway, so just do what you can to get it working again. Please.`);
    mc.talk(`Will do.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_13);
    mc.talk(`By the way, how many drives to you have?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_15);
    alex.talk(`Drives...?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_14);
    alex.talk(`It's not related to cars is it?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_11);
    mc.talk(`Mmm... Do you save your files only on your desktop?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_16);
    alex.talk(`Ah...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_17);
    ann.talk(`In case you don't understand he doesn't mean to your actual desk...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_18);
    ann.talk(`Hehehehe!`);
    alex.talk(`Hey, you bitch!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_11);
    mc.talk(`Do you have any important files? They might get deleted.`);
    alex.talk(`Not any that I can think of... I keep the important stuff on my phone.`);
    alex.talk(`Just do what you can do in order to get it to work again. Please!`);
    mc.talk(`I'll try my best, but it might take a while. It depends on your laptop's speed.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_13);
    mc.talk(`Just don't ask me to install Office... I hate that shit.`);
    alex.talk(`Haha, alright!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_14);
    alex.talk(`Ann... What's Office?`, { method: "Whispering" });
    ann.talk(`Hehe.`);



    return jump(V7AlexAnnMC_CheckingComments, "V7AlexAnnMC_CheckingComments");
};
export const V7AlexAnnMC_CheckingComments = async (): Promise<any> => {
    doWaitImageByTime(images.v7.V7AlexAnnMC_22);
    alex.talk(`So where were we?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_19);
    mc.talk(`We were going over the comments on the pic with the guitar.`);
    ImageClass.setImage({ ...images.v7.V7AlexAnnMC_32, partialsToDisplay: [images.v7.V7AlexAnnMC_32.partials.V7AlexAnnMC_32_p] });
    alex.talk(`Right! This one.`);
    ann.talk(`Yeah.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_19);
    ann.talk(`Check this one, from Suri: "Oh wow !! What an amazing guitar ! How long have you been playing?"`);
    ann.talk(`He seems nice. Why didn't you reply?`);
    alex.talk(`Because I don't know how to play... It was just there for the #AD haha.`);
    ann.talk(`I see.`);
    doWaitImageByTime(images.v7.V7AlexAnnMC_20);
    ann.talk(`What about: "Oh damn, look at the curves on that guitar, sheeesh! 🤤" from tern.`);
    ann.talk(`I don't think he is talking about the guitar...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_21);
    alex.talk(`You think?`);
    doWaitImageByTime(images.v7.V7AlexAnnMC_19);
    ann.talk(`Ok, next one!`);
    ImageClass.setImage({ ...images.v7.V7AlexAnnMC_32, partialsToDisplay: [images.v7.V7AlexAnnMC_32.partials.V7AlexAnnMC_32_p_2] });
    if (!ann.properties.isCorrupted && mc.properties.annStatus === "gf") {
        ann.talk(`Oh my! You don't have any panties on!`);
        alex.talk(`Relax. They can't see anything.`);
        ann.talk(`I guess...`);

    } else {
        ann.talk(`Oh wow, that's a kinky photo!`);
        alex.talk(`I love it! It turned out great!`);

    }
    doWaitImageByTime(images.v7.V7AlexAnnMC_20);
    ann.talk(`Almost all the comments are on your bear.`);
    alex.talk(`I know! Like what the hell! He gets all the attention.`);
    ann.talk(`He is cute! Hehe.`);
    doWaitImageByTime(images.v7.V7AlexAnnMC_19);
    ann.talk(`Look at this one: "show pancakes!" by scooterb.`);
    ann.talk(`What does that mean?`);
    alex.talk(`I have no idea... You know how weird people over the internet can be...`);
    ann.talk(`Yes. Hehe.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_29);
    alex.talk(`How are things looking?`);
    mc.talk(`Not bad, I'm just settings up your partitions so next time, if this happens, you'll keep most of your files.`);
    alex.talk(`That's sounds smart! Thank you!`);
    mc.talk(`You're welcome!`);
    alex.talk(`I hope we aren't distracting you.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_30);
    mc.talk(`Not at all.`);
    alex.talk(`Great!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_20, { duration: 1 });
    ann.talk(`Everyone keeps talking about your teddy bear!`);
    ann.talk(`Look what fabfab wrote: "I like your bear. Him and I have a lot in common."`);
    alex.talk(`He is right!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_19);
    ann.talk(`What's the teddy's name anyway?`);
    alex.talk(`Chucky!`);
    ann.talk(`Oh. Hehe.`);
    ann.talk(`Wait... Look at this comment by red_guy: "Don't want to scare you, but that bear seems to be following you".`);
    doWaitImageByTime(images.v7.V7AlexAnnMC_31);
    ann.talk(`Did you say the bear's name is Chucky?`);
    alex.talk(`Yes.`);
    ann.talk(`Like the bear from the horror movie?`);
    doWaitImageByTime(images.v7.V7AlexAnnMC_26);
    alex.talk(`Y-yes...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_27);
    ann.talk(`Wasn't he near the door earlier?`);
    alex.talk(`He w-was...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_28);
    ann.talk(`HEHEHE!`);
    alex.talk(`Haha!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_23, { duration: 1 });
    alex.talk(`We are just joking Chucky.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_24, { duration: 1 });
    alex.talk(`Muah!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_25, { duration: 1 });
    ann.talk(`Now I'm starting to believe all those comments saying you are doing stuff with him...`);
    alex.talk(`Of course I do!`);
    if (mc.properties.annStatus === "hate" || ann.properties.isCorrupted) {

        ann.talk(`Can I borrow him?`);
        if (mc.properties.annStatus === "hate") {
            alex.talk(`Why? Chris isn't satisfying you?`);
            ann.talk(`...`);

        } else {
            alex.talk(`He is mine!`);

        }

    } else {

        ann.talk(`Oh my...`);
    }

    ImageClass.setImage(images.v7.V7AlexAnnMC_20);
    ann.talk(`Woah, I didn't see this one.`);
    ImageClass.setImage({ ...images.v7.V7AlexAnnMC_32, partialsToDisplay: [images.v7.V7AlexAnnMC_32.partials.V7AlexAnnMC_32_p_3] });
    alex.talk(`Really? I love it.`);

    if (mc.properties.annStatus === "hate" || ann.properties.isCorrupted) {


    } else {
        ann.talk(`You are... Topless.`);
        alex.talk(`It's not the first time, why are you so surprised?`);
        ann.talk(`Because on the other ones you keep covering them... And here...`);
        alex.talk(`I covered them with emojis!`);
    }
    ann.talk(`Who took that picture anyway?`);
    alex.talk(`I did... I set my phone on timer... It was a nightmare.`);
    alex.talk(`It kept falling down. I have like twenty pictures of my table.`);
    ann.talk(`Oh wow, it looks good, the angle looks like someone professional took it.`);
    alex.talk(`Thank you!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_19);
    ann.talk(`Look at: "fuggin slut. Love her." by getoutofmylab.`);
    if (mc.properties.annStatus === "hate" || ann.properties.isCorrupted) {
        ann.talk(`What a nice guy!`);
        alex.talk(`Haha.`);

    } else {
        ann.talk(`Is slut supposed to be a compliment?`);
        alex.talk(`On Insta it is...`);
        ann.talk(`Interesting...`);
    }



    return jump(V7AlexAnnMC_LaptopFixed, "V7AlexAnnMC_LaptopFixed");
};
export const V7AlexAnnMC_LaptopFixed = async (): Promise<any> => {
    doWaitImageByTime({ ...images.v7.V7AlexAnnMC_22, partialsToDisplay: [{ ...images.v7.V7AlexAnnMC_22.partials.V7AlexAnnMC_22_p, options: { duration: 1 } }], });
    // ImageClass.setImage({ ...images.v7.V7AlexAnnMC_22, partialsToDisplay: [images.v7.V7AlexAnnMC_22.partials.V7AlexAnnMC_22_p] }, { duration: 2 });
    mc.talk(`Ok, we are... Done!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_33, { duration: 1 });
    alex.talk(`Really?!?`);
    mc.talk(`Yes, you are all set.`);
    alex.talk(`Thank you!!!`);
    if (mc.properties.annStatus === "hate") {

        mc.think(`She is so flirty...`);
    } else {

        mc.think(`She is so flirty... I wonder if it makes Ann jealous or she is blindly trusting Alex.`);
    }
    ImageClass.setImage(images.v7.V7AlexAnnMC_34, { duration: 1 });
    mc.talk(`And I also have a surprise!`);
    alex.talk(`You do? I love surprises!`);
    mc.talk(`There is a program that can recover some of the deleted files.`);
    mc.talk(`It doesn't always work but I tried running it anyway.`);
    alex.talk(`And?`);
    mc.talk(`It seems like it managed to recover some files.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_35);
    alex.talk(`Really??`);
    mc.talk(`Yes, look.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_36, { shake: true });
    empty.think(`*Click*`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_37);
    mc.think(`Holy shit! I wasn't expecting that!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_38);
    alex.talk(`Oh my!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_39, { duration: 0, shake: true });
    mc.talk(`Ouch!`, { wait: 1 });
    ImageClass.setImage(images.v7.V7AlexAnnMC_40);
    alex.talk(`You didn't see that.`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_41);
    ann.talk(`See what?`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_42, { duration: 1 });
    alex.talk(`Something personal...`);
    ann.talk(`What's that? I want to see too!`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_43);
    alex.talk(`Nah... I told you, it's really nothing.`);
    ann.talk(`Why can't I see it then?`);
    mc.talk(`It seems like you have some things to talk about...`);
    ImageClass.setImage(images.v7.V7AlexAnnMC_44);
    mc.talk(`So... I'll just head out.`);
    alex.talk(`Thanks a lot for your help ${mc.name}!`);
    alex.talk(`You are a lifesaver!`);




    return jump(V7AlexAnnMC_LaptopFixedLeaving, "V7AlexAnnMC_LaptopFixedLeaving");
};

export const V7AlexAnnMC_LaptopFixedLeaving = async (): Promise<any> => {
    if (Question.globalAnswers?.V7AlexAnnMCGoodByeResultBeforeLeavingArr?.includes("ann")) {
        ImageClass.setImage(images.v7.V7AlexAnnMC_47);
    } else {
        ImageClass.setImage(images.v7.V7AlexAnnMC_44);
    }
    await mc.setQuestion(new Question({ text: `You're welcome!`, options: { think: false, array: 'V7AlexAnnMCGoodByeResultBeforeLeavingArr' }, key: `V7AlexAnnMCGoodByeResultBeforeLeaving` })
        .option({ title: `Kiss Ann goodbye`, key: `ann`, show: isAnnGF() && !Question.globalAnswers.V7AlexAnnMCGoodByeResultBeforeLeavingArr?.includes("ann") })
        .option({ title: `Hug Alex goodbye`, key: `alex`, show: !Question.globalAnswers.V7AlexAnnMCGoodByeResultBeforeLeavingArr?.includes("alex") })
        .option({ title: `leave`, key: `leave` }));


    if (Question.globalAnswers.V7AlexAnnMCGoodByeResultBeforeLeaving === "ann") {
        ImageClass.setImage(images.v7.V7AlexAnnMC_45, { duration: 1 });
        ann.talk(`Muah!`);
        await mc.set((properties) => {
            properties.annRelationship++;
        });


    } else if (Question.globalAnswers.V7AlexAnnMCGoodByeResultBeforeLeaving === "alex") {
        ImageClass.setImage(images.v7.V7AlexAnnMC_46, { duration: 1, wait: true, hideText: true });
        await mc.set((properties) => {
            properties.alexRelationship++;
        });

    } else {

        return jump(V7AlexAnnMC_End, "V7AlexAnnMC_End");
    }

    return jump(V7AlexAnnMC_LaptopFixedLeaving, "V7AlexAnnMC_LaptopFixedLeaving");
};

export const V7AlexAnnMC_End = async (): Promise<any> => {
    return jump(V7AlexAnnMCAfter, "V7AlexAnnMCAfter");
};